import { useCallback, useState } from 'react';
import { DropdownMenu } from '../components/form';
import { TimeFrame } from '../components/Widget/types';
import { useTranslation } from 'react-i18next';

export const INTERVALS = [
  'VAR_LAST',
  'VAR_24H',
  'VAR_7D',
  'VAR_30D',
  'VAR_1Y',
  'VAR_ALL',
] as const;

export type TInterval = (typeof INTERVALS)[number];
/**
 * If the function "handleInterval" is called without a parameter the interval
 * will be reset
 */
export const useIntervals = (
  availableIntervals: TInterval[] = ['VAR_7D', 'VAR_30D', 'VAR_1Y', 'VAR_ALL'],
  defaultInterval: TInterval = 'VAR_ALL'
) => {
  const intervals = INTERVALS.filter((int) => availableIntervals.includes(int));
  const [interval, setInterval] = useState<TInterval>(
    intervals.includes(defaultInterval)
      ? defaultInterval
      : intervals[intervals.length - 1]
  );

  const { t } = useTranslation();

  const handleClick = useCallback(
    (label?: string, value?: string) =>
      setInterval((value as TimeFrame) || INTERVALS[0]),
    []
  );

  const IntervalSelector = ({ className = '' }: { className?: string }) => {
    return (
      <DropdownMenu
        dropdownClassName={`
          flex
          items-center
          h-16
          w-32
          px-4
          ${className}
        `}
        dropdownTooltipClassName={`
          bg-white
          border-solid
          border
          border-grey-30
        `}
        dropdownArrowClassName="-right-5 bottom-1.5 text-black"
        dropdownItems={intervals.map(
          (interval) => t('widget.intervals.' + interval) as string
        )}
        dropdownItemsData={intervals as TimeFrame[]}
        showArrow
        handleClick={handleClick}
      >
        {t('widget.intervals.' + interval)}
      </DropdownMenu>
    );
  };

  return {
    interval,
    setInterval,
    IntervalSelector,
    handleInterval: handleClick,
  };
};
